import PageData from '../../common/ts/PageData';
import HipflatForm from "./HipflatForm";
import HipflatContactModal from "./HipflatContactModal";
import ChatButtons from "../../common/ts/forms/ChatButtons";
import HipflatStickyButtons from "./common/HipflatStickyButtons";
import HipflatScheduleModal from "./common/HipflatScheduleModal";
import HipflatPhoneModal from "./HipflatPhoneModal";
import '@justinribeiro/lite-youtube';

window.addEventListener("load", () => {
    // @ts-ignore
    const pageData: PageData = window.wl.pageData

    HipflatStickyButtons.init(pageData);
    HipflatForm.init(pageData);
    HipflatContactModal.init(pageData);
    ChatButtons.init(pageData);
    HipflatScheduleModal.init(pageData);
    HipflatPhoneModal.init(pageData);
    document.getElementById("go-back")?.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        history.go(-1);
    });
});
